/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SimulationProgress } from '../../models/simulation-progress';

export interface SimulationProgressGet$Params {
  raceGuid: string;
}

export function simulationProgressGet(http: HttpClient, rootUrl: string, params: SimulationProgressGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SimulationProgress>> {
  const rb = new RequestBuilder(rootUrl, simulationProgressGet.PATH, 'get');
  if (params) {
    rb.query('raceGuid', params.raceGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SimulationProgress>;
    })
  );
}

simulationProgressGet.PATH = '/simulation-progress';
